import { jsonGet, jsonPost } from 'api'

const base64Credentials = btoa(`${window.NPS_ADMIN_USERNAME}:${window.NPS_ADMIN_PASSWORD}`)

export const getAllUsersSurveysByCountry = (country, language, userId) =>
    jsonGet(`${SF_PROXY_URL}/nps/${country}/${language}/${userId}`).catch(error => {
        throw new Error(error.message)
    })

export const sendUsersSurveyByUseId = (country, language, userId, rating, ratingText) =>
    jsonPost(`${SF_PROXY_URL}/nps/${country}/${language}/${userId}`, { rating, ratingText }).catch(error => {
        throw new Error(error.message)
    })

export const getAllSurveysByCountryAdmin = country =>
    jsonGet(`${SF_PROXY_URL}/admin/nps/${country}`, null, {
        Authorization: `Basic ${base64Credentials}`,
    }).catch(error => {
        throw new Error(error.message)
    })

export const getSurveyResultsById = (country, surveyId) =>
    jsonGet(`${SF_PROXY_URL}/admin/nps/${country}/${surveyId}`, null, {
        Authorization: `Basic ${base64Credentials}`,
    }).catch(error => {
        throw new Error(error.message)
    })

export const getSurveyTextAnswersById = (country, surveyId, page = 1, pageSize = 6, rating = -1) =>
    jsonGet(
        `${SF_PROXY_URL}/admin/nps/${country}/${surveyId}/answers?page=${page}&pageSize=${pageSize}&rating=${rating}`,
        null,
        {
            Authorization: `Basic ${base64Credentials}`,
        }
    ).catch(error => {
        throw new Error(error.message)
    })

export const addNewSurveyByCountry = (country, newSurvey) =>
    jsonPost(`${SF_PROXY_URL}/admin/nps/${country}`, newSurvey, {
        Authorization: `Basic ${base64Credentials}`,
    }).catch(error => {
        throw new Error(error.message)
    })

export const getSurveyCSV = async (country, id) => {
    try {
        const response = await fetch(`${SF_PROXY_URL}/admin/nps/${country}/${id}/answers_csv`, {
            method: 'GET',
            headers: { Authorization: `Basic ${base64Credentials}` },
        })
        return await response.blob()
    } catch (error) {
        throw new Error(error.message)
    }
}
